import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"PT_Sans_Narrow\",\"arguments\":[{\"weight\":[\"400\",\"700\"],\"subsets\":[\"latin\",\"cyrillic\"],\"variable\":\"--font-sans-narrow\"}],\"variableName\":\"sans_narrow\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":[\"400\",\"500\"],\"subsets\":[\"latin\",\"cyrillic\"],\"variable\":\"--font-montserrat\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"PT_Sans_Caption\",\"arguments\":[{\"weight\":[\"400\"],\"subsets\":[\"latin\",\"cyrillic\"],\"variable\":\"--font-sans-caption\"}],\"variableName\":\"sans_caption\"}");
;
import(/* webpackMode: "eager" */ "/app/public/images/ig.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/nd.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/tg.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/vk.svg");
;
import(/* webpackMode: "eager" */ "/app/public/images/yt.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HeaderMenu/HeaderMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RunningLine/RunningLine.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/Noise/Noise.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.scss");
